"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vendors = void 0;
const core_1 = require("../core");
class Vendors extends core_1.CrowdinApi {
    listVendors(options, deprecatedOffset) {
        if ((0, core_1.isOptionalNumber)(options)) {
            options = { limit: options, offset: deprecatedOffset };
        }
        const url = `${this.url}/vendors`;
        return this.getList(url, options.limit, options.offset);
    }
}
exports.Vendors = Vendors;
